import { get, find, some, filter } from 'lodash/fp';
import { createSelector } from 'reselect';
import { SmtpAccountStatus } from '../../../../../constants/smtp-account';

export const getSettingsPortalSmtpAccount = get('settings.portal.smtpAccount');

export const getSmtpAccounts = createSelector(
  getSettingsPortalSmtpAccount,
  get('all')
);

export const getSmtpAccountForType = createSelector(
  (_, type) => type,
  getSmtpAccounts,
  find
);

export const getActiveSmtpAccounts = createSelector(
  getSmtpAccounts,
  filter({ status: SmtpAccountStatus.ACTIVE })
);

export const getHasActiveSmtpAccount = createSelector(
  getSmtpAccounts,
  some({ status: SmtpAccountStatus.ACTIVE })
);

export const getIsFetching = createSelector(
  getSettingsPortalSmtpAccount,
  get('fetching')
);
export const getIsFetched = createSelector(
  getSettingsPortalSmtpAccount,
  get('fetched')
);
export const getFetchingError = createSelector(
  getSettingsPortalSmtpAccount,
  get('fetchingError')
);

export const getIsSaving = createSelector(
  getSettingsPortalSmtpAccount,
  get('saving')
);
export const getIsSaved = createSelector(
  getSettingsPortalSmtpAccount,
  get('saved')
);
export const getSavingError = createSelector(
  getSettingsPortalSmtpAccount,
  get('savingError')
);
